import http from "../http-common";

class TaskEngineService {
    getTaskTypes = () => http.get('/taskengine/task-types');

    createJob = (data) => http.post('/taskengine/jobs', data);

    getJobs = () => http.get('/taskengine/jobs');

    getJobById = (jobId) => http.get(`/taskengine/jobs/${jobId}`);

    getJobsbyTaskTypeId = (taskTypeId) => http.get(`/taskengine/jobs?task_type_id=${taskTypeId}`);

    getFailedJobs = () => http.get('/taskengine/jobs/failed');

    updateJobStatus = (job_id, status) => http.put(`/taskengine/jobs/${job_id}/status`, status);

    getJobExecutionHistory = (job_id) => http.get(`/taskengine/execution-history/job/${job_id}`);

    getMissedReminderStats = (job_id) => http.get(`/taskengine/misc/patient-reminder-stats/${job_id}`);

    sendMissedReminders = (data, job_id) => http.post(`/taskengine/misc/send-missed-reminders/${job_id}`, data);
}
export default new TaskEngineService();